import EditTravelAdmin from '@/requests/travels/admin/editTravelAdmin'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/_authenticated/requests/viewTravel/$id/editTravel',
)({
    beforeLoad: ({ context }) => {
        if (!context.user) {
            throw redirect({ to: '/login' })
        }
        const { isAdmin } = context.userRoles
        if (!isAdmin) {
            throw redirect({ to: '/unauthorized' })
        }
    },
    component: EditTravelPage,
})

function EditTravelPage() {
    return <EditTravelAdmin />
}
